import DateInput from "../../../../components/UI/PageInput/DateInput";

function CustomDateSelector({ setValue, register, from, to, errors }) {
  return (
    <div className={`flex max-w-xl gap-2`}>
      <DateInput
        label="From *"
        name={"from"}
        value={from}
        setValue={setValue}
        register={{
          ...register("from", {
            required: "Please select start date",
          }),
        }}
        error={errors.from}
        disableFutureDays={true}
      />
      <DateInput
        label="To *"
        name={"to"}
        value={to}
        setValue={setValue}
        register={{
          ...register("to", {
            required: "Please select end date",
          }),
        }}
        error={errors.to}
        disableFutureDays={true}
      />
    </div>
  );
}

export default CustomDateSelector;
